module.exports = __webpack_public_path__ + "static/media/ACHSLogo.7fe40b7c.svg";